













































import { Component, Vue, Prop } from 'vue-property-decorator';
import ReferralStatusWiseCount from './ReferralStatusWiseCount.vue';
import CandidateList from './CandidateList.vue';
import { vxm } from '@/store.vuex';
declare var window: any;

@Component({
  name: 'JobReferralCard',
  components: {
    ReferralStatusWiseCount,
    CandidateList,
  },
})
export default class JobReferralCard extends Vue {
  @Prop() referral;
  @Prop() variableIncentiveEnabled;
  @Prop({ default: '' }) referralLevel;
  get getId() {
    return this.referral.referralCode;
  }
  get brandLogo() {
    const COMPANY_LOGO_URL = vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    );
    const LOGO_FILE_SEPERATOR = '/';
    const LOGO_FILE = vxm.utility.companyLogoFile;
    const CompanyLogoUrl =
      COMPANY_LOGO_URL +
      LOGO_FILE_SEPERATOR +
      this.referral.companyCode +
      LOGO_FILE_SEPERATOR +
      LOGO_FILE;
    return CompanyLogoUrl;
  }

  get total() {
    return (
      (this.referral.totalFixedPoints || 0) + 
      (this.referral.totalVariablePoints || 0)
    );
  }

  get currency() {
    return (
      this.referral.incentiveQuantityUOM ||
      vxm.configs.getCompanyPreference('CURRENCY', 'companyCurrency')
    );
  }

  get canShowReferralIncentive() {
    return vxm.configs.getGlobalConfigValue('SHOW_REFERRAL_INCENTIVE')
  }

  get canShowZeroIncentive() {
    return (this.total > 0) || vxm.configs.getGlobalConfigValue('ZERO_INCENTIVE_ENABLED');
  }
}
